// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = () => {
  return [
    {
      name: '合同编号',
      prop: 'salesOrderNo',
      type: 'input',
      disabled: true,
      span: 7,
    },
    {
      name: '收款登记号',
      prop: 'registerNo',
      type: 'input',
      span: 7,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    field: 'depositNo',
    title: '押金编号',
    visible: true,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称 ',
    visible: true,
  },
  {
    field: 'leaseDateFrom',
    title: '租赁期限',
    visible: true,
  },
  {
    field: 'depositAmount',
    title: '押金金额（元）',
    visible: true,
  },
  {
    field: 'depositBalance',
    title: '押金余额（元）',
    visible: true,
  },
  {
    field: 'realityDeductionAmount',
    title: '本次抵扣金额原币',
    visible: true,
    editRender: { name: 'realityDeductionAmount' },
  },
  // {
  //   field: 'realityDeductionAmount',
  //   title: '抵扣金额（元）',
  //   visible: true,
  // },
];
export const tableList = [
  {
    id: 1,
    registerNo: 1111,
    purchaseOrderNo: '12qwert',
    payeeName: 'A',
    requestAmount: '9000',
    paidAmount: 5000,
    deductionAmount: 4000,
    realityDeductionAmount: '1',
  },
  {
    id: 2,
    registerNo: 2222,
    purchaseOrderNo: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 9000,
    deductionAmount: 8000,
    realityDeductionAmount: '',
  },
  {
    id: 3,
    registerNo: 3333,
    purchaseOrderNo: 'eee',
    payeeName: ' B',
    requestAmount: '9000',
    paidAmount: 8000,
    deductionAmount: 8000,
    realityDeductionAmount: '',
  },
];
